import React from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";

interface ProcessingInfoProps {
  document: StratifyDocument;
}

export const ProcessingInfo: React.FC<ProcessingInfoProps> = ({ document }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "success";
      case "processing":
        return "warning";
      case "failed":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Processing Status
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Status
            </Typography>
            <Chip
              data-testid="processing-status"
              label={document.metadata?.processing?.status ?? "unknown"}
              color={getStatusColor(
                document.metadata?.processing?.status ?? "unknown"
              )}
              variant="outlined"
            />
          </Stack>
        </Box>
        {document.metadata?.processing?.completedAt && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Completed At
              </Typography>
              <Typography>
                {document.metadata?.processing?.completedAt
                  ? document.metadata.processing.completedAt
                      .toDate()
                      .toLocaleString()
                  : ""}
              </Typography>
            </Stack>
          </Box>
        )}
        {document.metadata?.processing?.error && (
          <Box sx={{ flex: "1 1 100%" }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="error">
                Error
              </Typography>
              <Typography color="error">
                {document.metadata?.processing?.error.message}
              </Typography>
            </Stack>
          </Box>
        )}
        {document.metadata?.processing?.result?.pageCount && (
          <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Page Count
              </Typography>
              <Typography>
                {document.metadata?.processing?.result?.pageCount} pages
              </Typography>
            </Stack>
          </Box>
        )}
      </Box>
    </Paper>
  );
};
